let config = {
  adminHost: 'https://services.leemma.com/',
  APIhost: 'https://services.leemma.com/api/base' // ubuntu Server
  // APIhost:"http://114.215.131.216/api/base/" //debain Server
//   APIhost:"/api/base" //local
}
if (process.env.NODE_ENV == 'development') {
    config.api = '/api/private/';
} else if (process.env.NODE_ENV == 'debug') {
    config.api = '/api/private/';
} else if (process.env.NODE_ENV == 'production') {
    config.api = 'https://services.leemma.com/api/private/';
}
export default config



// WEBPACK FOOTER //
// ./src/lib/config.js